import { PureComponent } from 'react'
import { $ } from 'utils'
import styled from 'glamorous'
import TextareaAutosize from 'react-autosize-textarea'

const NameContainer = styled.div({
  display: 'inline-flex',
  flex: 1,
  marginRight: 15
})

const Textarea = styled(TextareaAutosize)({
  display: 'inline-flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: 0,
  width: '100%',
  fontSize: '19px',
  fontWeight: '700',
  border: 'none !important',
  outline: 'none !important',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
})

const Name = styled.div({
  display: 'inline-flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '19px',
  fontWeight: '700',
  cursor: 'pointer',
  whiteSpace: 'normal',
  wordBreak: 'break-word'
})

class EditableName extends PureComponent {

  state = {
    value: this.props.value,
    editMode: false
  }

  setEditMode = () => {
    this.setState({ editMode: true })
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value })
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.onUpdate(e.target.value)
      this.setState({ editMode: false })
    }
  }

  handleBlur = (e) => {
    this.props.onUpdate(e.target.value)
    this.setState({ editMode: false })
  }

  render () {
    const { editMode, value } = this.state
    return (
      $(NameContainer,
        editMode
          ? $(Textarea, {
              value,
              onChange: this.handleChange,
              onBlur: this.handleBlur,
              onKeyDown: this.handleKeyDown,
              autoFocus: true,
              maxLength: 128
            })
          : $(Name, {
              onClick: this.setEditMode
            }, value.length > 0 ? value : 'Enter description')
      )
    )
  }
}

export default EditableName


// WEBPACK FOOTER //
// ./src/components/EditableName.js